const k = () => {
};
function P() {
  try {
    return window.__nv_debug ? !0 : new URLSearchParams(window.location.search).has("nvdbg");
  } catch {
    return !1;
  }
}
const R = P();
function H(n) {
  if (!R) return { debug: k, info: k, warn: k, error: k };
  const r = `[nv:${n}]`;
  return {
    debug: (e, ...t) => console.debug(r, e, ...t),
    info: (e, ...t) => console.info(r, e, ...t),
    warn: (e, ...t) => console.warn(r, e, ...t),
    error: (e, ...t) => console.error(r, e, ...t)
  };
}
const m = { for: H, enabled: R }, h = m.for("tracker:mraid");
function E() {
  return window.mraid ?? null;
}
class N {
  constructor() {
    this._inView = !1, this._callbacks = null, this._threshold = 0.5, this._readyCb = null, this._exposureCb = null, this._viewableCb = null;
  }
  static isSupported() {
    const r = E();
    return r !== null && typeof r.isViewable == "function" && typeof r.addEventListener == "function";
  }
  observe(r, e, t) {
    this._threshold = e, this._callbacks = t;
    const i = E();
    if (!i) {
      h.warn("mraid disappeared between isSupported and observe");
      return;
    }
    try {
      i.getState() === "loading" ? (h.debug("mraid loading, waiting for ready"), this._readyCb = () => {
        try {
          this._init(i);
        } catch (s) {
          h.error("mraid ready handler threw", s);
        }
      }, i.addEventListener("ready", this._readyCb)) : this._init(i);
    } catch (s) {
      h.error("mraid observe setup threw", s);
    }
  }
  _init(r) {
    if (this._callbacks) {
      if (this._tryExposureChange(r)) {
        h.info("using MRAID 3.0 exposureChange");
        return;
      }
      h.info("using MRAID 2.0 viewableChange"), this._useViewableChange(r);
    }
  }
  _tryExposureChange(r) {
    try {
      const e = r;
      if (typeof e.getVersion != "function") return !1;
      const t = parseFloat(e.getVersion());
      if (isNaN(t) || t < 3) return !1;
    } catch {
      return !1;
    }
    try {
      return this._exposureCb = (e) => {
        try {
          if (!Number.isFinite(e)) return;
          const t = e >= this._threshold * 100;
          this._callbacks?.onStateObserved?.(t), t && !this._inView ? (this._inView = !0, h.debug("in view (exposure)", { pct: e }), this._callbacks?.onInView()) : !t && this._inView && (this._inView = !1, h.debug("out of view (exposure)", { pct: e }), this._callbacks?.onOutOfView());
        } catch (t) {
          h.error("exposureChange callback threw", t);
        }
      }, r.addEventListener("exposureChange", this._exposureCb), !0;
    } catch {
      return this._exposureCb = null, !1;
    }
  }
  _useViewableChange(r) {
    this._viewableCb = (e) => {
      try {
        if (typeof e != "boolean") return;
        this._callbacks?.onStateObserved?.(e), e && !this._inView ? (this._inView = !0, h.debug("in view (viewable)"), this._callbacks?.onInView()) : !e && this._inView && (this._inView = !1, h.debug("out of view (viewable)"), this._callbacks?.onOutOfView());
      } catch (t) {
        h.error("viewableChange callback threw", t);
      }
    };
    try {
      r.addEventListener("viewableChange", this._viewableCb);
    } catch (e) {
      h.error("mraid addEventListener threw", e);
      return;
    }
    try {
      const e = r.isViewable();
      if (typeof e != "boolean") return;
      this._callbacks?.onStateObserved?.(e), e && !this._inView && (this._inView = !0, h.debug("already in view on init"), this._callbacks?.onInView());
    } catch (e) {
      h.warn("isViewable() threw", e);
    }
  }
  destroy() {
    const r = E();
    if (r) {
      if (this._readyCb) {
        try {
          r.removeEventListener("ready", this._readyCb);
        } catch {
        }
        this._readyCb = null;
      }
      if (this._exposureCb) {
        try {
          r.removeEventListener("exposureChange", this._exposureCb);
        } catch {
        }
        this._exposureCb = null;
      }
      if (this._viewableCb) {
        try {
          r.removeEventListener("viewableChange", this._viewableCb);
        } catch {
        }
        this._viewableCb = null;
      }
      this._callbacks = null, h.debug("destroyed");
    }
  }
}
const f = m.for("tracker:omid");
function L() {
  try {
    const n = window.omid;
    if (n?.verificationClient && typeof n.verificationClient.isSupported == "function")
      return n.verificationClient.isSupported() ? n.verificationClient : null;
  } catch {
  }
  return null;
}
class z {
  constructor() {
    this._client = null, this._callbacks = null, this._threshold = 0.5, this._inView = !1, this._initialized = !1, this._pendingObserve = !1, this._sessionCb = null, this._geometryCb = null;
  }
  static isSupported() {
    return L() !== null;
  }
  observe(r, e, t) {
    if (this._threshold = e, this._callbacks = t, this._client = L(), !this._client) {
      f.warn("OMID client not available after isSupported passed");
      return;
    }
    this._sessionCb = (i) => {
      try {
        i?.type === "sessionStart" && (this._initialized = !0, f.debug("session started"), this._pendingObserve && this._setupGeometryListener());
      } catch (s) {
        f.error("session observer callback threw", s);
      }
    };
    try {
      this._client.registerSessionObserver(this._sessionCb, "neuronic");
    } catch (i) {
      f.error("registerSessionObserver threw", i);
      return;
    }
    this._initialized ? this._setupGeometryListener() : (this._pendingObserve = !0, f.debug("waiting for session start"));
  }
  _setupGeometryListener() {
    if (!(!this._client || !this._callbacks)) {
      this._geometryCb = (r) => {
        try {
          if (!r?.geometryFrame) return;
          const e = r.geometryFrame.percentageInView;
          if (!Number.isFinite(e)) return;
          const t = e >= this._threshold * 100;
          this._callbacks?.onStateObserved?.(t), t && !this._inView ? (this._inView = !0, f.debug("in view", { pct: e }), this._callbacks?.onInView()) : !t && this._inView && (this._inView = !1, f.debug("out of view", { pct: e }), this._callbacks?.onOutOfView());
        } catch (e) {
          f.error("geometryChange callback threw", e);
        }
      };
      try {
        this._client.addEventListener("geometryChange", this._geometryCb), this._pendingObserve = !1, f.debug("geometry listener registered");
      } catch (r) {
        f.error("addEventListener geometryChange threw", r);
      }
    }
  }
  destroy() {
    if (this._client && this._geometryCb) {
      try {
        this._client.removeEventListener("geometryChange", this._geometryCb);
      } catch {
      }
      this._geometryCb = null;
    }
    this._sessionCb = null, this._callbacks = null, this._client = null, f.debug("destroyed");
  }
}
const p = m.for("tracker:io"), U = 5e-3;
class W {
  constructor() {
    this._observer = null, this._inView = !1, this._intersecting = !1, this._visibilityHandler = null;
  }
  static isSupported() {
    return typeof IntersectionObserver < "u";
  }
  observe(r, e, t) {
    const i = this._buildThresholds(e);
    p.debug("observing", { threshold: e, thresholds: i }), this._observer = new IntersectionObserver(
      (s) => {
        try {
          for (const o of s) {
            const a = o.boundingClientRect, c = a.width > 0 && a.height > 0, d = o.isIntersecting ?? o.intersectionRatio > 0;
            this._intersecting = c && d && o.intersectionRatio >= e - U, this._reconcile(t);
          }
        } catch (o) {
          p.error("IO callback threw", o);
        }
      },
      { root: null, threshold: i }
    ), this._observer.observe(r), this._visibilityHandler = () => {
      this._reconcile(t);
    }, document.addEventListener("visibilitychange", this._visibilityHandler);
  }
  destroy() {
    this._observer && (this._observer.disconnect(), this._observer = null), this._visibilityHandler && (document.removeEventListener("visibilitychange", this._visibilityHandler), this._visibilityHandler = null), p.debug("destroyed");
  }
  /**
   * Reconcile the effective in-view state from intersection + page visibility.
   * The element is only "in view" if it's intersecting AND the page is visible.
   */
  _reconcile(r) {
    const e = this._intersecting && !document.hidden;
    r.onStateObserved?.(e), e && !this._inView ? (this._inView = !0, p.debug("in view"), r.onInView()) : !e && this._inView && (this._inView = !1, p.debug("out of view", { hidden: document.hidden, intersecting: this._intersecting }), r.onOutOfView());
  }
  _buildThresholds(r) {
    return Array.from(/* @__PURE__ */ new Set([0, r, 1])).sort((t, i) => t - i);
  }
}
const V = m.for("tracker:poll"), x = 200;
class B {
  constructor() {
    this._timer = null, this._inView = !1;
  }
  static isSupported() {
    return typeof document < "u";
  }
  observe(r, e, t) {
    V.debug("observing", { threshold: e, interval: x });
    const i = () => {
      try {
        const s = this._visibleFraction(r), o = s >= e;
        t.onStateObserved?.(o), o && !this._inView ? (this._inView = !0, V.debug("in view", { fraction: s }), t.onInView()) : !o && this._inView && (this._inView = !1, V.debug("out of view", { fraction: s }), t.onOutOfView());
      } catch (s) {
        V.error("poll check threw", s);
      }
    };
    i(), this._timer = setInterval(i, x);
  }
  destroy() {
    this._timer !== null && (clearInterval(this._timer), this._timer = null, V.debug("destroyed"));
  }
  _visibleFraction(r) {
    const e = r.getBoundingClientRect(), t = e.width * e.height;
    if (t === 0) return 0;
    const i = window.innerWidth || document.documentElement.clientWidth, s = window.innerHeight || document.documentElement.clientHeight, o = Math.max(0, Math.min(i, e.right) - Math.max(0, e.left)), a = Math.max(0, Math.min(s, e.bottom) - Math.max(0, e.top));
    return o * a / t;
  }
}
const O = m.for("detect"), G = [
  { type: "mraid", ctor: N },
  { type: "io", ctor: W },
  { type: "omid", ctor: z },
  { type: "poll", ctor: B }
];
function K() {
  for (const { type: n, ctor: r } of G)
    try {
      if (r.isSupported())
        return O.info("selected", { type: n }), { tracker: new r(), type: n };
    } catch (e) {
      O.warn("isSupported threw", { type: n, err: e });
    }
  return O.error("no supported tracker found"), null;
}
const y = m.for("observe");
function I(n) {
  const { element: r, threshold: e, safetyTimeout: t, callbacks: i } = n;
  let s = !1, o = null, a = !1;
  const c = K();
  if (!c)
    return y.warn("no tracker available, failing open immediately"), i.onError?.(new Error("No viewability tracker available")), i.onInView(), { stop: () => {
    }, trackerType: "none" };
  const { tracker: d, type: u } = c, b = () => {
    o !== null && (clearTimeout(o), o = null);
  };
  o = setTimeout(() => {
    try {
      if (s) return;
      o = null;
      let l = !1;
      try {
        const _ = r.getBoundingClientRect();
        l = _.width <= 0 || _.height <= 0;
      } catch {
        l = !1;
      }
      if (l) {
        y.warn("safety timeout on a zero-area element, failing closed", { tracker: u }), i.onError?.(new Error(`Safety timeout: ${u} did not report a state and element has zero area`));
        return;
      }
      a = !0, y.warn("safety timeout reached, failing open", { elapsed: t, tracker: u }), i.onError?.(new Error(`Safety timeout: ${u} did not report a state within ${t}ms`)), i.onInView();
    } catch (l) {
      y.error("safety timeout callback threw", l);
    }
  }, t);
  try {
    d.observe(r, e, {
      onStateObserved: (l) => {
        s || (b(), a && !l && (a = !1, i.onOutOfView()));
      },
      onInView: () => {
        if (!s) {
          if (b(), a) {
            a = !1;
            return;
          }
          i.onInView();
        }
      },
      onOutOfView: () => {
        s || (b(), i.onOutOfView());
      }
    });
  } catch (l) {
    return y.error("tracker.observe() threw", { tracker: u, err: l }), i.onError?.(l instanceof Error ? l : new Error(String(l))), b(), i.onInView(), { stop: () => {
    }, trackerType: "none" };
  }
  return { stop: () => {
    if (!s) {
      s = !0, b();
      try {
        d.destroy();
      } catch (l) {
        y.error("tracker.destroy() threw", l);
      }
      y.debug("stopped", { tracker: u });
    }
  }, trackerType: u };
}
const C = m.for("duration"), v = typeof performance < "u" && performance.now ? () => performance.now() : () => Date.now();
function Y(n) {
  const { interval: r, onPing: e } = n;
  let t = null, i = 0, s = 0, o = 0, a = !1, c = !1;
  function d() {
    t !== null && (clearTimeout(t), t = null);
  }
  function u() {
    if (d(), !a || c) return;
    const w = Math.max(0, r - (v() - o));
    t = setTimeout(b, w);
  }
  function b() {
    if (t = null, !a || c) return;
    const w = v(), S = w - o;
    if (S >= r) {
      o = w;
      try {
        e({ delta: S, totalDuration: i + (w - s) });
      } catch (F) {
        C.error("onPing threw", F);
      }
    }
    u();
  }
  function g() {
    if (c || a) return;
    a = !0;
    const w = v();
    s = w, o = w, C.debug("timer started", { accumulatedMs: i, interval: r }), u();
  }
  function l() {
    c || !a || (a = !1, d(), i += v() - s, C.debug("timer paused", { accumulatedMs: i }));
  }
  function _() {
    c || (c = !0, d(), a && (i += v() - s, a = !1), C.debug("timer destroyed", { accumulatedMs: i }));
  }
  return {
    start: g,
    pause: l,
    destroy: _,
    get totalDuration() {
      return i + (a ? v() - s : 0);
    }
  };
}
const D = ["pointerdown", "pointermove", "scroll", "keydown"], j = 100;
function q(n) {
  let r = Date.now(), e = !1, t = null;
  const i = () => {
    e || (e = !0, r = Date.now(), t = setTimeout(() => {
      e = !1;
    }, j));
  }, s = { passive: !0, capture: !0 };
  for (const o of D)
    document.addEventListener(o, i, s);
  return {
    isIdle() {
      return Date.now() - r > n;
    },
    destroy() {
      for (const o of D)
        document.removeEventListener(o, i, s);
      t !== null && (clearTimeout(t), t = null);
    }
  };
}
const T = {
  threshold: 0.5,
  interval: 500,
  safetyTimeout: 5e3,
  idleTimeout: 3e4
};
function J(n) {
  const r = n.threshold ?? T.threshold, e = n.interval ?? T.interval, t = n.safetyTimeout ?? T.safetyTimeout, i = n.idleTimeout ?? T.idleTimeout;
  let s = "none", o = !1, a = !1, c = null;
  const d = i < 1 / 0 ? q(i) : null, u = Y({
    interval: e,
    onPing: (_) => {
      if (d?.isIdle()) {
        u.pause(), a = !0, b();
        return;
      }
      n.onPing({
        delta: _.delta,
        totalDuration: _.totalDuration,
        tracker: s
      });
    }
  });
  function b() {
    c === null && (c = setInterval(() => {
      (!d || !d.isIdle()) && (g(), o && (a = !1, u.start()));
    }, 1e3));
  }
  function g() {
    c !== null && (clearInterval(c), c = null);
  }
  const l = I({
    element: n.element,
    threshold: r,
    safetyTimeout: t,
    callbacks: {
      onInView: () => {
        o = !0, a || u.start();
      },
      onOutOfView: () => {
        o = !1, u.pause(), g(), a = !1;
      },
      onError: n.onError
    }
  });
  return s = l.trackerType, () => {
    u.destroy(), l.stop(), g(), d?.destroy();
  };
}
const A = {
  threshold: 0.5,
  safetyTimeout: 3e3
};
function Q(n) {
  const r = n.threshold ?? A.threshold, e = n.safetyTimeout ?? A.safetyTimeout;
  let t = !1;
  const i = I({
    element: n.element,
    threshold: r,
    safetyTimeout: e,
    callbacks: {
      onInView: () => {
        t || (t = !0, n.onView({ tracker: i.trackerType }), i.stop());
      },
      onOutOfView: () => {
      },
      onError: n.onError
    }
  });
  return () => {
    i.stop();
  };
}
const M = {
  threshold: 0.5,
  safetyTimeout: 5e3
}, $ = () => Date.now();
function X(n) {
  const r = n.threshold ?? M.threshold, e = n.safetyTimeout ?? M.safetyTimeout;
  let t = 0;
  const i = I({
    element: n.element,
    threshold: r,
    safetyTimeout: e,
    callbacks: {
      onInView: () => {
        t = $(), n.onChange({
          isInView: !0,
          duration: 0,
          tracker: i.trackerType
        });
      },
      onOutOfView: () => {
        const s = t > 0 ? $() - t : 0;
        t = 0, n.onChange({
          isInView: !1,
          duration: s,
          tracker: i.trackerType
        });
      },
      onError: n.onError
    }
  });
  return () => {
    i.stop();
  };
}
export {
  Q as onFirstView,
  X as onViewChange,
  J as trackDuration
};
//# sourceMappingURL=viewability.es.js.map
